/**
 * @description used to determine time format for the current user
 */
export enum TimeFormat {
  Frames = 'FRAMES',
  Seconds = 'SECONDS',
  Milliseconds = 'MILLISECONDS',
}
